/* eslint-disable */
document.documentElement.classList.add('no-touch');
window.addEventListener('touchstart', function onFirstTouch() {
    document.documentElement.classList.remove('no-touch');
    document.documentElement.classList.add('touch');
    window.removeEventListener('touchstart', onFirstTouch, false);
}, false);

